module.exports = __webpack_public_path__ + "static/media/yesterdayImageDesktop3.435f9d8e.png";